<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content [innerHTML]="description">
</div>
<div mat-dialog-content *ngIf="showTickAgree">
  <mat-checkbox class="example-margin" [(ngModel)]="IAgree">I agree with the above conditions</mat-checkbox>
</div>
<div mat-dialog-actions>
  <br>
  <button mat-raised-button color="primary" (click)="onNoClick()" *ngIf="hideClose!=true">Close</button>&nbsp;
  <button mat-raised-button color="primary" *ngIf="showConfirm" (click)="onYesClick()" cdkFocusInitial>{{confirmText}}</button>
</div>